import { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import FeuE1AdequacyMonitoringPlan from './FeuE1AdequacyMonitoringPlan/FeuE1AdequacyMonitoringPlan';
import FeuE2DataFlowActivities from './FeuE2DataFlowActivities/FeuE2DataFlowActivities';
import FeuE3RiskAssessment from './FeuE3RiskAssessment/FeuE3RiskAssessment';
import FeuE4ControlActivities from './FeuE4ControlActivities/FeuE4ControlActivities';
import FeuE5RelevantData from './FeuE5RelevantData/FeuE5RelevantData';
import FeuE6CorrectiveActions from './FeuE6CorrectiveActions/FeuE6CorrectiveActions';
import FeuE7OutsourcedActivities from './FeuE7OutsourcedActivities/FeuE7OutsourcedActivities';
import FeuE8Documentation from './FeuE8Documentation/FeuE8Documentation';

const FeuManagement = ({ data, refetchMonitoringData,vesselMstId }) => {
    const [expandedPanel, setExpandedPanel] = useState('panel1');

    const autoSaveForE1 = useRef();
    const autoSaveForE2 = useRef();
    const autoSaveForE3 = useRef();
    const autoSaveForE4 = useRef();
    const autoSaveForE5 = useRef();
    const autoSaveForE6 = useRef();
    const autoSaveForE7 = useRef();
    const autoSaveForE8 = useRef();

    const handleChange = (panel) => async (_, isExpanded) => {
        let isSubmitSuccess = true;

        if (expandedPanel === 'panel1' && autoSaveForE1.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE1.current.submitAndCheck();
        } else if (expandedPanel === 'panel2' && autoSaveForE2.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE2.current.submitAndCheck();
        } else if (expandedPanel === 'panel3' && autoSaveForE3.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE3.current.submitAndCheck();
        } else if (expandedPanel === 'panel4' && autoSaveForE4.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE4.current.submitAndCheck();
        } else if (expandedPanel === 'panel5' && autoSaveForE5.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE5.current.submitAndCheck();
        } else if (expandedPanel === 'panel6' && autoSaveForE6.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE6.current.submitAndCheck();
        } else if (expandedPanel === 'panel7' && autoSaveForE7.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE7.current.submitAndCheck();
        } else if (expandedPanel === 'panel8' && autoSaveForE8.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForE8.current.submitAndCheck();
        }
        if (!isSubmitSuccess) return;
        setExpandedPanel(isExpanded ? panel : false);
    };

    const methods = useForm({
        mode: 'onBlur',
        defaultValues: {
            NameOfTheShip: '',
        },
    });

    const renderTitleWithIcon = (panel, title) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {expandedPanel === panel ? '−' : '+'}
            </span>
            <p className="fuel-cons">{title}</p>
        </div>
    );
    return (
        <FormProvider {...methods}>
            <form>
                <Accordion defaultExpanded expanded={expandedPanel === 'panel1'} onChange={handleChange('panel1')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel1', 'E.1 Regular check of the adequacy of the monitoring plan')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuE1AdequacyMonitoringPlan
                            FeuE1AdequacyMonitoringPlanData={data?.e1MonitoringPlanChecks}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE1}
                            vesselMstId={vesselMstId}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel2'} onChange={handleChange('panel2')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel2', 'E.2 Procedures for data flow activities')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuE2DataFlowActivities
                            FeuE2DataFlowActivitiesData={data?.e2DataFlowProcedures}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE2}
                            vesselMstId={vesselMstId}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel3'} onChange={handleChange('panel3')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel3', 'E.3 Procedures for risk assessment')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuE3RiskAssessment
                            FeuE3RiskAssessmentData={data?.e3RiskAssessmentProcedures}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE3}
                            vesselMstId={vesselMstId}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel4'} onChange={handleChange('panel4')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel4', 'E.4 Control activities: Quality assurance and reliability of information technology')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuE4ControlActivities
                            FeuE4ControlActivitiesData={data?.e4ControlActivities}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE4}
                            vesselMstId={vesselMstId}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel5'} onChange={handleChange('panel5')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel5', 'E.5  Control activities: Internal reviews and validation of relevant data')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuE5RelevantData
                            FeuE5RelevantData={data?.e5ControlActivities}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE5}
                            vesselMstId={vesselMstId}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel6'} onChange={handleChange('panel6')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel6', 'E.6 Control activities: Corrections and corrective actions')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuE6CorrectiveActions
                            FeuE6CorrectiveActionsData={data?.e6ControlActivities}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE6}
                            vesselMstId={vesselMstId}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel7'} onChange={handleChange('panel7')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel7', 'E.7 Control activities: Outsourced activities (if applicable)')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuE7OutsourcedActivities
                            FeuE7OutsourcedActivitiesData={data?.e7ControlActivities}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE7}
                            vesselMstId={vesselMstId}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel8'} onChange={handleChange('panel8')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel8', 'E.8 Control activities: Documentation')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuE8Documentation
                            FeuE8DocumentationData={data?.e8ControlActivities}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForE8}
                            vesselMstId={vesselMstId}
                        />
                    </AccordionDetails>
                </Accordion>
            </form>
        </FormProvider>
    );
};

export default FeuManagement;
